import { ITC_TABLE_DATA, LOADER_STATUS } from "./constants";

export const initialState = {
  loaderStatus: false,
  itcTableData: [],
};

/* eslint-disable default-case, no-param-reassign */
const gstr2a2bNewITCReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case ITC_TABLE_DATA:
      return {
        ...state,
        itcTableData: action.itcTableData,
      };

    default:
      return state;
  }
};

export default gstr2a2bNewITCReducer;
